import React from 'react';
import About from '../content/About';
import Policy from '../content/Policy';
import Gallery from '../content/Gallery';
import Location from './Location';
import Partners from './Partners';
import Creatives from './Creatives';
import Sponsors from './Sponsors';

interface EventContentProps {
  event: any;
  loading?: boolean;
  error?: string | null;
  loadingHeavy?: {
    images?: boolean;
    addons?: boolean;
    organizer?: boolean;
  };
}

const EventContent: React.FC<EventContentProps> = ({ 
  event, 
  loading = false, 
  error = null,
  loadingHeavy = {}
}) => {
  if (loading) {
    return (
      <div className="event-content-card">
        <div className="event-content-body">
          <div className="d-flex justify-content-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading content...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="event-content-card">
        <div className="event-content-body">
          <div className="alert alert-warning" role="alert">
            <strong>Content Loading Error:</strong> {error}
          </div>
        </div>
      </div>
    );
  }

  if (!event) {
    return null;
  }

  return (
    <div className="event-content-card">
      <div className="event-content-body">
        {/* About Section */}
        <About event={event} />
        
        {/* Gallery Section - Inside event content */}
        {loadingHeavy.images ? (
          <div className="gallery-section">
            <h2 className="section-title">
              <i className="fas fa-images me-2"></i>
              Gallery
            </h2>
            <div className="d-flex justify-content-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading gallery...</span>
              </div>
            </div>
          </div>
        ) : event.images && event.images.length > 0 ? (
          <Gallery event={event} />
        ) : null}
        
        {/* Creatives Section */}
        {event.creatives && event.creatives.length > 0 && (
          <Creatives event={event} />
        )}
        
        {/* Policy Section */}
        <Policy event={event} />
        
        {/* Location Section */}
        {event.venue && (
          <Location venue={event.venue} />
        )}
      </div>
    </div>
  );
};

export default EventContent;
